// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4e840453","484":"c55caa63"}[chunkId] + ".chunk.js";
};